
import ServicePageLayout from "@/components/ServicePageLayout";
import StyledBulletPoint from "@/components/StyledBulletPoint";
import { Button } from "@/components/ui/button";

const Hypnose = () => {
  const openCalendly = () => {
    window.open("https://calendly.com/meneora/hypnose-therapeutique-pro", "_blank");
  };

  return (
    <ServicePageLayout
      heroImage="/lovable-uploads/81739330-c321-4d85-8384-6b903b35f39e.png"
      heroAlt="Hypnose thérapeutique pour praticiens"
      heroTitle="Hypnose thérapeutique – clarté & libération intérieure"
      heroText="Une séance pour explorer, libérer et réintégrer. Hypnose profonde pour praticiens en transition ou en surcharge."
    >
      {/* Pour qui section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="max-w-4xl mx-auto">
          <h2 className="section-title text-center mb-8">Quand la posture ne résonne plus</h2>
          <div className="space-y-3 mt-8">
            <StyledBulletPoint>Tu ressens un décalage dans ta pratique</StyledBulletPoint>
            <StyledBulletPoint>Tu portes des poids qui ne t'appartiennent plus</StyledBulletPoint>
            <StyledBulletPoint>Tu veux retrouver ton axe, ton sens</StyledBulletPoint>
          </div>
        </div>
      </section>

      {/* Déroulé section */}
      <section className="mb-16 reveal-on-scroll">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="section-title mb-6">Un espace sûr pour libérer en profondeur</h2>
            <p className="mb-6 text-foreground/80">
              Echange préalable + définition de l'intention.
            </p>
            <p className="mb-4 text-foreground/80">Puis :</p>
            <div className="space-y-3 mb-6">
              <StyledBulletPoint>Exploration des blocages</StyledBulletPoint>
              <StyledBulletPoint>Libération des conflits internes</StyledBulletPoint>
              <StyledBulletPoint>Intégration des ressources profondes</StyledBulletPoint>
            </div>
          </div>
          <div>
            <img 
              src="/lovable-uploads/81739330-c321-4d85-8384-6b903b35f39e.png"
              alt="Hypnose thérapeutique pour praticiens – séance en visio ou présentiel" 
              className="rounded-lg shadow-md w-full"
            />
          </div>
        </div>
      </section>

      {/* Réservation section */}
      <section className="bg-accent/10 p-8 rounded-lg reveal-on-scroll">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="section-title mb-4">Prendre rendez-vous</h2>
          <p className="text-xl mb-8">
            Durée : 1h – Tarif : 80 € – En visio ou à Étampes
          </p>
          <Button size="lg" onClick={openCalendly}>
            Réserver
          </Button>
        </div>
      </section>
    </ServicePageLayout>
  );
};

export default Hypnose;
